export function extractRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "EXTRACT_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "EXTRACT_FULFILLED":           
        case "EXTRACT_STOP":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "EXTRACT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}

export function importCSV(file){
    return async function(dispatch){
        dispatch({
            type: "EXTRACT_START",
            payload: ""
        })
        try {
            const response = await fetch('/extract/inventory/stocks/import',{
                method:'POST',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                body: JSON.stringify(file),
                credentials: 'same-origin',
            })     
            const res = await response.json();
            console.log({res});
            if(res.error === "OK"){
                console.log("[INFO] importCSV ", res.processID);
                return res.processID
            } else {
                console.log("[ERROR] importCSV ", res.error);
            }      
        } catch (err) {
            console.log("[ERROR],  fetch csv ",err)
            dispatch({
                type: "EXTRACT_ERROR",
                payload: err
                
            })
        }
    }
}
export function generateCSV(type, dates, product_id){
    return async function(dispatch){
        dispatch({
            type: "EXTRACT_START",
            payload: ""
        })
        try {
            const response = await fetch('/extract/inventory/stocks/generate',{
                method:'POST',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                body: JSON.stringify({type, dates: dates, product_id}),
                credentials: 'same-origin',
            })     
            const res = await response.json();
            console.log({res});
            if(res.error === "OK"){
                console.log("[INFO] generateCSV ", res.processID);
                return res.processID
            } else {
                // this.props.notif(true, "danger", res.content, "Erreur")
                console.log("[ERROR] generateCSV ", res.error);
            }      
        } catch (err) {
            console.log("[ERROR],  fetch csv ",err)
            dispatch({
                type: "EXTRACT_ERROR",
                payload: err
                
            })
        }
    }
}

export function statusCSV(processID){
    return async function(dispatch){
        try {
            const response = await fetch('/extract/inventory/stocks/status',{
                method:'POST',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                body:JSON.stringify({processid:processID}),
                credentials: 'same-origin',
            })     
            const res = await response.json();
            console.log({res});
            if(res.error === "OK"){
                console.log("[INFO] statusCSV ", res.dataset);
                return res.dataset
            }
        } catch (err) {
            console.log("[ERROR],  fetch csv ",err)
        }
    }
}

export function stopProcessCSV(processID){
    return async function(dispatch){
        try {
            const response = await fetch('/extract/inventory/process/stop',{
                method:'POST',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                body:JSON.stringify({processid:processID}),
                credentials: 'same-origin',
            })     
            let blob = await response.json();
            console.log({blob});        
            dispatch({ type: "EXTRACT_STOP", payload:"" })
        } catch (err) {
            console.log("[ERROR],  fetch csv ",err)
        }
    }
}


export function downloadCSV(processid,type){
    return async function(dispatch){
        dispatch({
            type: "EXTRACT_START",
            payload: ""
        })
        try {
            const response = await fetch('/extract/inventory/stocks/download',{
                method:'POST',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                body:JSON.stringify({processid:processid}),
                credentials: 'same-origin',
            })        
            // const res = await response.json();
            // console.log("FETCH CSV", {res});
            // if (res.error ){
            //     console.log("[ERROR], fetch CSV response ",res)                   
            //     dispatch({
            //         type: "EXTRACT_ERROR",
            //         payload: res.error.message
                    
            //     })
            //     return;
            // }
            let blob = await response.blob();
            console.log({blob});     
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            let title = {
                "sales": "Historique_Ventes",
                "direct-sales": "Historique_Ventes_Directes",
                "direct-sales-grouped": "Ventes_Directes_Format_Sage_Comptable",
                "revenues-sage": "Revenues_Format_Sage",
                "revenues-installation-sage": "Ventes_Installation_Format_Sage",
                "commercials": "Commercial",
                "inventory": "Historique_Stock",
                "stocklist": "Inventaire",
                "com-stock": "Commercial Stock",
                "value-stock": "Valeur Stocks",
                "best-sellers": "Meilleures_Ventes",
                "reappro-err": "Reappro",
                "priceList": "Liste_Produits",
                "price-details": "Prix_Produits",
                "COGS": "Management_Accounts",
                "product-distribution": "Distribution_Produits",
                "temp-factures": "Template_Link_Factures_5000",
                "temp-priceList": "Template_Grille_Prix_Produits",
                "temp-product-info": "Template_Prix_Produits",
                "client-code-comptable": "Liste_Clients_Code_Comptable",
            }
            link.setAttribute('download', `MyJouleBox-${title[type]}.csv`);

            // 3. Append to html page
            document.body.appendChild(link);
            // 4. Force download
            link.click();
            // 5. Clean up and remove the link
            link.parentNode.removeChild(link);

            dispatch({ type: "EXTRACT_FULFILLED", payload:"" })
            
        } catch (err) {
            console.log("[ERROR],  downloadCSV ",err)
            dispatch({
                type: "EXTRACT_ERROR",
                payload: err
                
            })
        }
    }
}